// extracted by mini-css-extract-plugin
export default {"dropdown-indicator-base":"DropdownIndicatorBase_dropdown-indicator-base__Lmb8j"};